import loader from './loader/index.js';



export { loader as default };
